<div class="column custom-form__block" :class="columnWidthClass">
	<div class="is-flex is-h-100">
		<b-field :type="labelColor" :message="fieldMessage">
			<b-checkbox :type="fieldType" :name="field.name" :required="field.required" :modelValue="isChecked" @update:modelValue="onInput">
				<div :class="labelColor" v-html="field.labelHtml"></div>
			</b-checkbox>
		</b-field>
	</div>
</div>
